<template>
  <v-app>
    <v-container>
      <v-row class="justify-center">
        <h1>Whoops something went wrong...</h1>
      </v-row>
      <v-row class="justify-center">
        <h2>{{ error }}</h2>
      </v-row>
      <v-row class="justify-center">
        <router-link to="/">Back to Gluid</router-link>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import router from "@/router";

export default {
  // beforeRouteUpdate(to, from, next){
  //   console.log(to.query.error);
  //   this.error = to.query.error;
  //   next();
  // },
  // Has to be done like this? Tried above with the beforeRouteUpdate function but it did not work?
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.error = to.query.error;
      //used to hide query parameters
      router.replace({
        ...router.currentRoute,
        query: {
          error: undefined
        }
      });
    });
  },
  data() {
    return {
      error: null
    };
  }
};
</script>
